import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 200px;

  svg {
    cursor: pointer;
  }

  @media (max-width: 992px) {
    height: 330px;
  }
`

export const Item = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: black;
  @media (max-width: 992px) {
    height: auto;
  }
`

export const Slider = styled.div`
  overflow: hidden;
  position: relative;
  flex: 1;
  height: 100%;
`

export const Inner = styled.div`
  white-space: nowrap;
  transition: transform 0.3s;
  display: flex;
  gap: 20px;
  position: absolute;
  left: 0;
  top: 0;
  transform: ${({ transform }) =>
    transform ? `translateX(-${transform}px)` : '0'};
  ${Item} {
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
  }
`
